import { useUser } from "@clerk/react";
import { toast } from "sonner";
import { useApi } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { PageHeader, Panel } from "@/components/common";

const INTEGRATIONS = [
  ["int_brain", "Claude Sonnet 5.5", "ok"],
  ["int_kb", "BM25 (local)", "ok"],
  ["int_voice", "Browser Speech", "ok"],
  ["int_youtube", "YouTube Live API", "oauth"],
  ["int_payments", "Stripe (test)", "ok"],
];

export default function Settings() {
  const { t, lang, setLang } = useT();
  const api = useApi();
  const { user } = useUser();
  const changeLang = async (l) => {
    setLang(l);
    try { await api.patch("/me", { language: l }); toast.success(t("saved")); } catch { /* local preference still applied */ }
  };
  return (
    <div>
      <PageHeader eyebrow={t("nav_settings")} title={t("settings_title")} />
      <div className="grid lg:grid-cols-2 gap-4">
        <Panel data-testid="profile-panel">
          <p className="eyebrow mb-4">{t("profile")}</p>
          <div className="flex items-center gap-4">
            {user?.imageUrl && <img src={user.imageUrl} alt="" className="h-14 w-14 rounded-full" />}
            <div>
              <p className="font-display text-xl font-bold" data-testid="profile-name">{user?.fullName}</p>
              <p className="text-sm text-slate-400" data-testid="profile-email">{user?.primaryEmailAddress?.emailAddress}</p>
            </div>
          </div>
          <p className="eyebrow mt-8 mb-3">{t("ui_language")}</p>
          <div className="flex gap-2">
            {[["it", "Italiano"], ["en", "English"]].map(([k, label]) => (
              <button key={k} onClick={() => changeLang(k)} data-testid={`settings-lang-${k}`}
                className={`rounded-full px-5 py-2 text-sm border transition-colors ${lang === k ? "bg-indigo-600 border-indigo-500" : "border-white/15 hover:bg-white/5"}`}>{label}</button>
            ))}
          </div>
        </Panel>
        <Panel data-testid="integrations-panel">
          <p className="eyebrow mb-4">{t("integrations")}</p>
          <ul className="divide-y divide-white/[0.06]">
            {INTEGRATIONS.map(([k, name, st]) => (
              <li key={k} className="flex items-center justify-between py-3 text-sm">
                <span className="text-slate-300">{t(k)}</span>
                <span className="flex items-center gap-2">
                  <span className="text-slate-500">{name}</span>
                  <span className={`h-2 w-2 rounded-full ${st === "ok" ? "bg-emerald-500" : "bg-amber-400"}`} title={st} />
                </span>
              </li>
            ))}
          </ul>
        </Panel>
      </div>
    </div>
  );
}
